import type { TableColumns } from '@/vantage/types/TableConfig.types';
import _ from 'lodash';

export const findConditionIdColumnNames = (columns: TableColumns): string[] =>
  _.chain(columns)
    .values()
    .flatMap((group) => Object.entries(group))
    .filter(([, { meta }]) => meta?.type?.toString().toLowerCase() === 'condition_id')
    .map(([columnName]) => columnName)
    .value();

export const findConditions = (columns: TableColumns, conditionIdColumnNames: string[]): string[] =>
  _.chain(columns)
    .values()
    .flatMap((group) => Object.entries(group))
    .filter(
      ([, { meta }]) =>
        meta?.type?.toString().toLowerCase() === 'reference' && conditionIdColumnNames.includes(meta?.referenced),
    )
    .map(([columnName]) => columnName)
    .value();
